var heroData = {
    hello:"Bonjour, je m'appelle",
    name:"Edouard Mignien",
    title1:"Je suis un ingénieur",
    title2:"",
    click:"clickez moi"
}

exports.heroData = heroData